import React from 'react';
import { FacebookIcon, InstagramIcon, LinkedinIcon, TwitterIcon, AtSignIcon } from 'lucide-react';
const Footer: React.FC = () => {
  return <footer data-id="element-18">
      <div className="bg-[#39FF14] py-12 px-4" data-id="element-19">
        <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-20">
          <div className="flex flex-col" data-id="element-21">
            <span className="text-[#121212] font-thin mb-2" data-id="element-22">Email :</span>
            <a href="mailto:hassaanbasitali@gmail.com" className="text-[#121212] font-normal" data-id="element-23">
              hassaanbasitali@gmail.com
            </a>
          </div>
          <div className="flex flex-col" data-id="element-24">
            <span className="text-[#121212] font-thin mb-2" data-id="element-25">Call Today :</span>
            <a href="tel:+923001181588" className="text-[#121212] font-normal" data-id="element-26">
              +92 300 1181588
            </a>
          </div>
          <div className="flex flex-col" data-id="element-27">
            <span className="text-[#121212] font-thin mb-2" data-id="element-28">Social :</span>
            <div className="flex space-x-4" data-id="element-29">
              <a href="#" className="text-[#121212] hover:text-black transition-colors" data-id="element-30">
                <FacebookIcon size={20} data-id="element-31" />
              </a>
              <a href="#" className="text-[#121212] hover:text-black transition-colors" data-id="element-32">
                <InstagramIcon size={20} data-id="element-33" />
              </a>
              <a href="#" className="text-[#121212] hover:text-black transition-colors" data-id="element-34">
                <LinkedinIcon size={20} data-id="element-35" />
              </a>
              <a href="#" className="text-[#121212] hover:text-black transition-colors" data-id="element-36">
                <TwitterIcon size={20} data-id="element-37" />
              </a>
              <a href="#" className="text-[#121212] hover:text-black transition-colors" data-id="element-38">
                <AtSignIcon size={20} data-id="element-39" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#39FF14] border-t border-[#121212] border-opacity-20 py-4 px-4" data-id="element-40">
        <div className="container mx-auto" data-id="element-41">
          <p className="text-[#121212] font-thin text-sm" data-id="element-42">
            © Copyright 2025. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;